import React, { useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import Price from '../Components/Price'
import Container from '@material-ui/core/Container'
import { withRouter, useParams } from "react-router-dom"

const Orders = () => {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)

    const { phone } = useParams()

    const convertToLocalTime = (serverDate) => {

        if (!serverDate) return '-'

        try {

            let date

            // Firebase Timestamp
            if (serverDate.seconds) {
                date = new Date(serverDate.seconds * 1000)
            }
            // String / Date biasa
            else {
                date = new Date(serverDate)
            }

            if (isNaN(date.getTime())) {
                return '-'
            }

            return date.toLocaleString('id-ID', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })

        } catch (error) {
            return '-'
        }
    }

    useEffect(() => {

        const unsubscribe = auth.onAuthStateChanged(() => {

            db.collection("orders")
                .where("phone", "==", phone)
                .get()
                .then((querySnapshot) => {

                    let orders = []

                    querySnapshot.forEach((doc) => {
                        orders.push(doc.data())
                    })

                    setData(orders)
                    setLoading(false)
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(false)
                })
        })

        return () => unsubscribe()

    }, [phone])

    return (

        loading ?

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    background: '#fff'
                }}
            >
                <img
                    src="./loadingImg.gif"
                    alt="loading"
                    style={{ width: '120px' }}
                />
            </div>

            :

            <Container
                maxWidth="sm"
                style={{
                    paddingTop: '30px',
                    paddingBottom: '30px',
                    background: '#fff',
                    minHeight: '100vh'
                }}
            >

                {
                    data.length ?

                        data.map((d, i) => {

                            return (

                                <div
                                    key={i}
                                    style={{
                                        background: '#ffffff',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                        border: '1px solid #ddd',
                                        color: '#000'
                                    }}
                                >

                                    <div
                                        style={{
                                            borderBottom: '1px solid #ddd',
                                            paddingBottom: '12px',
                                            marginBottom: '15px'
                                        }}
                                    >
                                        <h2
                                            style={{
                                                margin: 0,
                                                color: '#000'
                                            }}
                                        >
                                            {d.name}
                                        </h2>

                                        <p
                                            style={{
                                                margin: '8px 0',
                                                color: '#000'
                                            }}
                                        >
                                            📞 {d.phone}
                                        </p>

                                        <p
                                            style={{
                                                margin: '8px 0',
                                                color: '#000'
                                            }}
                                        >
                                            📍 {d.address}
                                        </p>

                                        <p
                                            style={{
                                                margin: '8px 0',
                                                color: '#000'
                                            }}
                                        >
                                            ⏰ {convertToLocalTime(d.created_at)}
                                        </p>
                                    </div>

                                    <div>

                                        <h3
                                            style={{
                                                marginBottom: '10px',
                                                color: '#000'
                                            }}
                                        >
                                            Detail Pesanan
                                        </h3>

                                        {
                                            d.cartProducts.map((cp, i) => (

                                                <div
                                                    key={i}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '10px 0',
                                                        borderBottom: '1px dashed #ccc',
                                                        color: '#000'
                                                    }}
                                                >

                                                    <div>
                                                        <h4
                                                            style={{
                                                                margin: 0,
                                                                color: '#000'
                                                            }}
                                                        >
                                                            {cp.name}
                                                        </h4>
                                                    </div>

                                                    <div
                                                        style={{
                                                            color: '#000',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        x{cp.quantity}
                                                    </div>

                                                </div>

                                            ))
                                        }

                                    </div>

                                    <div
                                        style={{
                                            marginTop: '20px',
                                            textAlign: 'right'
                                        }}
                                    >

                                        <h2
                                            style={{
                                                margin: 0,
                                                color: '#000'
                                            }}
                                        >
                                            Total: <Price>{d.totalPrice}</Price>
                                        </h2>

                                    </div>

                                </div>

                            )

                        })

                        :

                        <div
                            style={{
                                textAlign: 'center',
                                marginTop: '100px',
                                color: '#000'
                            }}
                        >
                            <h2>Belum ada pesanan</h2>
                        </div>
                }

            </Container>
    )
}

export default withRouter(Orders)